import { flow } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { PersonalizedSearchModel, PersonalizedSearchPaths } from 'client/data/models/personalized-search';
import { getParamsFromVehicle } from 'site-modules/shared/utils/core-page/params';
import { withTrimSummary } from 'site-modules/personalized-search/components/with-trim-summary/with-trim-summary';

export const opinionDataProvider = flow(
  component =>
    connectToModel(component, {
      editorialTrims: bindToPath(
        ({ vehicle, trimSummary }) =>
          vehicle && trimSummary && PersonalizedSearchPaths.getEditorialTrims(getParamsFromVehicle(vehicle)),
        PersonalizedSearchModel,
        null,
        false
      ),
    }),
  withTrimSummary({})
);
